export default __webpack_public_path__ + "static/media/bullets.1409b2bc.png";